import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { FiltersBarComponent } from 'src/app/components/filters/filters-bar.component';
import { FiltersGroupingUI } from 'globals/store/filters-ui.models';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { SearchBarComponent } from 'src/app/components/search-bar';
import { Wrapper } from 'src/app/components/wrapper.component';
import { filterActions, filterPageTypes, filterTypes } from 'src/app/store/filters.era';

@Component({
    selector: 'dashboard-options-panel',
    template: `
<div class="event_view_filter_header">
  <div class="filter_left">
    <icon class="filterIcon" icon="filter_24px"></icon>
    <div class="filter_text">Filter events</div>
  </div>
  <div class="clear_filter" (click)="clearFilters()" *ngIf="!!filterCount">CLEAR FILTERS</div>
</div>
<search-bar class="desktop" [gray]="true" (keyword)="searchKey$.next($event)"></search-bar>
<filters-bar [filterGroupings]="filterGroupings" [filterPage]="filterPage"></filters-bar>
`,
    styleUrls: [`./dashboard-options-panel.scss`],
    imports: [FiltersBarComponent, CommonModule, SearchBarComponent, IconComponent],
    standalone: true
})
export class DashboardOptionsPanelComponent extends Wrapper<DashboardOptionsPanelComponent> implements OnInit, OnDestroy {
  searchKey$: Subject<string> = new Subject<string>();
  @Input() showSearch
  @Input() filterGroupings: FiltersGroupingUI[]
  @Output() close: EventEmitter<any> = new EventEmitter();
  @ViewChild(FiltersBarComponent, { static: true }) filtersBar: FiltersBarComponent
  @ViewChild(SearchBarComponent) searchBar: SearchBarComponent
  filterPage = filterPageTypes.home
  filterCount: number


  ngOnInit() {
    this.subObservableWithDebounce(this.searchKey$, 333, this.dispatchSearch.bind(this))
    this.subProp(this.store.select('filters', 'home', 'count'), 'filterCount')
  }

  clearFilters() {
    this.store.dispatch(filterActions.clearFilterGroup(filterPageTypes.home))
    this.filtersBar.clearFilter()
    this.searchBar.clear()
  }

  dispatchSearch(searchTerm: string) {
    this.store.dispatch(filterActions.updateFilter({
      filterPageType: filterPageTypes.home,
      filterType: filterTypes.search,
      value: searchTerm
    }))
  }

  ngOnDestroy() {
    this.dispatchSearch("") // <== Easiest way to clear out old searches between searches.
  }

}

